// Renders editor-level loading, error, deleted-document, and trash banners.
import React from "react";

import InlineSVG from "react-inlinesvg/esm";

export default function DocumentStatusBanners({ message, error, deleted, trashedItem, restoreDocument, restoreTrashedItem }) {
  return (
    <>
      {message && <div id="message">{message}</div>}
      {error && <div id="error">{error}</div>}

      {deleted && !trashedItem && (
        <div id="deleted-message">
          <InlineSVG src="/assets/warning.svg" />
          <span>
            This document is in the trash. <a onClick={restoreDocument}>Restore</a>
          </span>
        </div>
      )}

      {trashedItem && (
        <div id="deleted-message">
          <InlineSVG src="/assets/warning.svg" />
          <span>
            This {trashedItem.type} is in the trash. <a onClick={restoreTrashedItem}>Restore</a>
          </span>
        </div>
      )}
    </>
  );
}
